module.exports = __webpack_public_path__ + "static/technip-2d40a4a7d86739ea1a79c9570a1c630b.png";